import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { GTMBath, GTMMain } from '../../../../../constants/analytics/GTM';
import { mainContent } from '../../../../../constants/copyright';
import { BATH, MAIN } from '../../constants/localStates';
import { useContent } from '../../../../../redux/reducer/content';

const { bathroom } = mainContent;

export default function MainToggleBathButton() {
  const { isBath } = useContent();
  const localState = isBath ? BATH : MAIN;

  const callbacks = useApplicationCallbacks();
  const onClick = () => {
    ({ [BATH]: GTMMain, [MAIN]: GTMBath })[localState]?.();
    callbacks.setIsBath();
  };

  return (
    <SwitchTransition>
      <CSSTransition appear={true} key={localState} timeout={300}>
        <div
          className={classNames('main__bathroom', {
            'main__bathroom_to-main': localState === BATH,
            'main__bathroom_to-bath': localState === MAIN,
          })}
        >
          <CustomButton
            {...bathroom.attr}
            newType={'bath'}
            icon={`buttons/${isBath ? 'to-main' : 'to-bath'}`}
            onClick={onClick}
          >
            <div className={'main__bathroom-tutor'} data-tutor-id={'to-bath'} />
          </CustomButton>
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
}
